import { render, staticRenderFns } from "./selectCard.vue?vue&type=template&id=2f3d90ce&scoped=true"
import script from "./selectCard.vue?vue&type=script&lang=js"
export * from "./selectCard.vue?vue&type=script&lang=js"
import style0 from "./selectCard.vue?vue&type=style&index=0&id=2f3d90ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3d90ce",
  null
  
)

export default component.exports